export const FORMS = {
    PLACEHOLDER_TBD: "To Be Determined",
    DEFAULT_ERROR: "Oops! Some server error"
}